const model = {
    submitting: false,
    errors: null,
    typeDetails: null,
    success: false,
};

export default model;
